module.exports = __webpack_public_path__ + "static/media/Erangel_Main.a786ac74.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Erangel_Main.webp
// module id = ./src/assets/Erangel_Main.webp
// module chunks = 0